/**
 * Helper Object to transfer billing positions from the platform to the mail-service
 */
export class BillingPositionBody {

  propertyId: string;
  tempPropertyId: string;
  positionBodyText: string;

}
